module.exports = {
  spellcheckerFakeDoorTestExpiryDate: '2025-04-05T00:00:00.000Z',
}
